import { conversionTrackingApi } from '@ctct/infrastructure-layer';
import type { ConversionTrackingPayload } from '@ctct/infrastructure-layer';

interface ConversionTrackingData {
  soid?: string;
  plan?: string;
  amount?: number;
}

export class ConversionTrackingService {
  constructor(private trackingData: ConversionTrackingData) {}

  public handlers() {
    return {
      trackConversion: async (): Promise<boolean> => {
        if (!this.trackingData.soid) {
          // eslint-disable-next-line no-console
          console.error('[ConversionTracking] Missing SOID, cannot track conversion');

          return false;
        }

        try {
          const payload: ConversionTrackingPayload = {
            souid: this.trackingData.soid,
          };

          if (this.trackingData.plan || this.trackingData.amount !== undefined) {
            payload.properties = {};

            if (this.trackingData.plan) {
              payload.properties.plan = this.trackingData.plan;
            }

            if (this.trackingData.amount !== undefined) {
              payload.properties.amount = this.trackingData.amount;
            }
          }

          // eslint-disable-next-line no-console
          console.log('[ConversionTracking] Tracking conversion:', { souid: this.trackingData.soid });

          const response = await conversionTrackingApi.trackConversion(payload);

          // eslint-disable-next-line no-console
          console.log('[ConversionTracking] Success:', response.data.message);

          return true;
        } catch (error) {
          // eslint-disable-next-line no-console
          console.error('[ConversionTracking] Failed to track conversion:', error);

          return false;
        }
      },
    };
  }
}
